<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

//todo añadir en la documentación mitt
//todo Mostrar todos los mensajes del backend en el frontend con sweetalert

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.custom-swal-height {
  height: 700px !important;
  max-height: 90vh;
}
</style>
